import { createContractRequest } from './helper';
export const getVehicleCondition = createContractRequest({
    source: 'data',
    method: 'get',
    route: '/contract/offers/:offerId/vehicleCondition',
});
